import { render, staticRenderFns } from "./GpsrSafetyInfo.vue?vue&type=template&id=3163561a&"
import script from "./GpsrSafetyInfo.vue?vue&type=script&lang=js&"
export * from "./GpsrSafetyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Misha\\Documents\\GitHub\\gpsr\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3163561a')) {
      api.createRecord('3163561a', component.options)
    } else {
      api.reload('3163561a', component.options)
    }
    module.hot.accept("./GpsrSafetyInfo.vue?vue&type=template&id=3163561a&", function () {
      api.rerender('3163561a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/GpsrSafetyInfo.vue"
export default component.exports